import React, {useState} from "react";
import {Alert, Col, Input, Label, Row, Spinner} from "reactstrap";
import QButton from "../../../../common/components/QButton";
import {useTranslation} from "react-i18next";

interface Props {
    open: number | boolean, // open > 0 show
    setOpen: Function,
    callIntegration: Function,
    progress: number,
    showForceImport?:boolean
}

const BodyModalIntegrationComponent: React.FC<Props> = ({showForceImport = false,progress, setOpen, open, callIntegration, ...props}) => {
    const {t} = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);
    const [startDate, setStartDate] = useState<string>('');
    const [endDate, setEndDate] = useState<string>('');
    const [forceImport, setForceImport] = useState<boolean>(false);
    const synchronizing = progress > 0 && progress < 100;
    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const handleSubmit = async () => {
        if (progress === 0 && !synchronizing) {
            await callIntegration({startDate,endDate,forceImport});
        } else if (progress === 100) {
            setOpen(false);
        }

    }
    return (
        <React.Fragment>
            <Row>
                <Col>
                    {synchronizing && (
                        <Alert color="info" className="d-flex align-items-center gap-2">
                            <Spinner size="sm"/>
                            <span>{t("log.synchronizing")}</span>
                        </Alert>
                    )}
                    {progress === 100 && <Alert color="success">{t("log.sync_done")}</Alert>}

                    <div className={`slide-down-container ${isExpanded ? 'expanded' : ''}`}>
                        <div className="mb-3">
                            <Label>{t("log.start_date")}</Label>
                            <Input
                                type="datetime-local"
                                className={'form-control-zp'}
                                // style={{ paddingLeft: '20px' }}
                                value={startDate}
                                disabled={synchronizing}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>
                        <div className="mb-3">
                            <Label>{t("log.end_date")}</Label>
                            <Input
                                type="datetime-local"
                                className={'form-control-zp'}
                                value={endDate}
                                disabled={synchronizing}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>

                        {showForceImport && ( <div className="mb-3">
                            <Label>{t("log.force_import")}</Label>
                            <Input
                                style={{marginLeft:'10px'}}
                                type="checkbox"
                                className={'form-control-zp'}
                                checked={forceImport}
                                disabled={synchronizing}
                                onChange={(e) => setForceImport(e.target.checked)}
                            />
                        </div>)}
                    </div>


                    <div className={'text-end'}>
                        <QButton
                            type="secondary"
                            onClick={toggleExpand}
                            content={isExpanded ? t("log.hide_advanced") : t("log.show_advanced")}
                            disabled={synchronizing}
                        />
                        <QButton
                            type={(progress === 0 ? 'primary' : 'success')}
                            onClick={handleSubmit}
                            content={synchronizing ? t("log.synchronizing") : (progress === 100 ? t("common.button.close") : t("common.button.submit"))}
                            disabled={synchronizing}
                        />
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default BodyModalIntegrationComponent
